import React from 'react'

export default props => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g id="Working-artboards" fill="none" fillRule="evenodd">
      <g id="Fullscreen-mode" transform="translate(-1820 -1188)">
        <g id="Back" transform="rotate(-180 935.5 619.5)">
          <circle
            id="Oval-3"
            stroke="#00AFEC"
            fill="#FFF"
            cx="25"
            cy="25"
            r="25"
          />
          <path
            d="M26.6574714,28.6935029 L26.3072506,28.6935029 C21.7619485,28.6935029 17.2163854,28.6719489 12.6713443,28.703972 C10.8282487,28.7170276 9.99810539,27.4438634 10.0026724,26.215778 C10.005543,25.4152007 9.99340795,24.6145003 10.0054125,23.8140462 C10.0197658,22.8617288 10.3604613,22.0399671 11.2899034,21.5841307 C11.6749636,21.3951945 12.163759,21.3222804 12.605841,21.3205561 C17.1837643,21.3023275 21.7616875,21.309348 26.3396108,21.309348 L26.724671,21.309348 C26.6102359,21.1906162 26.5379474,21.1092037 26.4587433,21.0343189 C24.6078186,19.2831486 22.7611999,17.5279138 20.9024461,15.7842565 C20.1077947,15.0388576 19.803113,14.1746036 20.1336306,13.1534366 C20.2167493,12.8965129 20.3669372,12.635032 20.5580972,12.4377205 C21.1225737,11.8549003 21.7007512,11.2804553 22.314029,10.7440686 C23.4933492,9.71243245 24.9329863,9.76009759 26.0877754,10.8462961 C28.0442622,12.6865153 29.9947466,14.5322769 31.9475798,16.3760679 C34.3461485,18.6407161 36.7287981,20.9210064 39.1502017,23.1637312 C40.2162612,24.1511508 40.154281,25.4725959 39.6464348,26.2554373 C39.500553,26.4804611 39.3143514,26.6886112 39.1162757,26.8758231 C34.7767479,30.9806905 30.4333055,35.0823556 26.0892107,39.1831586 C24.9558211,40.2530992 23.3926151,40.2744069 22.2473514,39.232548 C21.7619485,38.7909989 21.2848966,38.3408281 20.8182835,37.8816663 C19.7021179,36.783028 19.7111213,35.3424816 20.8492084,34.2618255 C22.7121377,32.4930425 24.5845923,30.7331274 26.4545677,28.9709953 C26.5306403,28.8993129 26.6231539,28.8432724 26.7080994,28.7799653 C26.6912669,28.7511445 26.6743039,28.7223237 26.6574714,28.6935029"
            id="Left"
            fill="#00AFEC"
          />
        </g>
      </g>
    </g>
  </svg>
)
